<div class="modal-header">
  <h4 class="modal-title" i18n>Partner's feedback</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
  <div *ngFor="let feedback of feedbacks" class="card">
    <div class="card-header rounded">
      <span class="float-end">{{ feedback.created_at | date: 'EE' }} {{ feedback.created_at | date: 'shortDate' }}</span>
      <span *ngIf="feedback.rating">
        <span *ngIf="feedback.rating >= 0.5">
          <fa-icon [icon]="fa.faStar" size="lg" style="color: #ffd700;"></fa-icon>
        </span>
        <span *ngIf="feedback.rating >= 1.5">
          <fa-icon [icon]="fa.faStar" size="lg" style="color: #ffd700;"></fa-icon>
        </span>
        <span *ngIf="feedback.rating >= 2.5">
          <fa-icon [icon]="fa.faStar" size="lg" style="color: #ffd700;"></fa-icon>
        </span>
        <span *ngIf="feedback.rating >= 3.5">
          <fa-icon [icon]="fa.faStar" size="lg" style="color: #ffd700;"></fa-icon>
        </span>
        <span *ngIf="feedback.rating >= 4.5">
          <fa-icon [icon]="fa.faStar" size="lg" style="color: #ffd700;"></fa-icon>
        </span>
      </span>
      <p class="mt-3"style="white-space: pre-wrap;">{{ feedback.feedback }}</p>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>